<template>
  <div class="board-item">
    <div class="board-item__index">{{ index + 1 }}</div>
    <UserItem class="board-item__info" :avatar="target.avatar" :name="target.name" :ont="target.ontid" />
    <div class="board-item__label g-font-num-mid">{{ target.total ? `$${target.total}` : target.count }}</div>
  </div>
</template>

<script>
import UserItem from '@/components/UserItem.vue';

export default {
  name: 'BoardItem',
  components: { UserItem },
  props: {
    index: {
      type: Number,
      require: true,
    },
    target: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .board-item {
    display: flex;
    align-items: center;
    padding: 0 $padding-common;
    height: 80px;
    line-height: 80px;
    font-size: $font-size-base;
    &:hover {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .1);
    }
  }

  .board-item__index {
    width: 48px;
  }

  .board-item__info {
    flex: 1;
  }

  .board-item__label {
    margin-left: auto;
    font-size: 18px;
  }
</style>
